export default "__VITE_ASSET__Qgeh0dJi__"